import React from "react";
import Skeleton from "@/app/_partials/_skeleton/Skeleton";

export default function BannerSkeleton() {
  return (
    <>
      <Skeleton height={530} borderRadius={20} />

      <Skeleton height={382} borderRadius={20} className="mt-2" />
    </>
  );
}
